import * as Yup from 'yup';
export default function setFormikObjectInitialValues(textFieldProps,textFieldValue) {   
  const obj = {}
  for(let i =0;i<textFieldProps.length;i+=1){
    obj[textFieldProps[i]] = textFieldValue[i];
  }
  return obj
}
